// When link with anchor #compare-products is clicked and current page has a product number and does not contain a #compare-button element:
// * Navigate to parent page with #compare-products anchor appended
function productCompareLinkClick() {
  const productCompareLink = document.querySelector('a[href="#compare-products"]');
  const productCompareButton = document.querySelector('#compare-button');
  const productNumber = document.querySelector('[data-product-number]')?.dataset.productNumber;

  if (productCompareLink && productNumber && !productCompareButton) {
    productCompareLink.addEventListener('click', (event) => {
      console.log('product compare link');
      window.location.href = (window.location.pathname.trimEnd('/').split('/').slice(0, -1).join('/') 
        + `?sort=recommended&comparison_a=${productNumber}#compare-products`);
    });
  }
}

// When page loads, if current URL has anchor #compare-products:
// * Activate #compare-button element
// * Scroll to #products element
function productCompareButtonPageLoad() {
  if (window.location.hash === '#compare-products') {
    const productCompareButton = document.querySelector('#compare-button');
    const productsSection = document.querySelector('#products');

    if (productCompareButton) {
      productCompareButton.click();

      if (productsSection) {
          productsSection.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
      }
    }
  }
}


document.addEventListener('DOMContentLoaded', () => {
  productCompareLinkClick();
  productCompareButtonPageLoad();
});